module.exports = __webpack_public_path__ + "static/img/item12.7666abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item12.png
// module id = gPh2
// module chunks = 1